import React from "react";

export function SiteHeader() {
  return (
    <header className="site-header">
      <nav aria-label="Principal" className="site-header-inner">
        <a href="#topo" className="brand-inline">
          <span className="type-display">Conversas</span>
          <span className="type-voice">Terapêuticas</span>
        </a>
        <a href="https://manuelaxavier.com.br/login" className="login-link type-display">
          Login <span aria-hidden="true">→</span>
        </a>
      </nav>
    </header>
  );
}
